import type { PropsWithChildren } from "react";
import { useState } from "react";

import { Button } from "@/ui/core";
import { VStack } from "@/ui/layout";

const ReplayAnimationDecorator = ({ children }: PropsWithChildren) => {
  const [mountKey, setMountKey] = useState<number>(0);

  return (
    <VStack gap={16} padding={20} width="100%">
      <Button
        onPress={() => setMountKey((prev) => prev + 1)}
        testID="replay-button"
        title="Replay animation"
        variant="secondary"
      />
      <VStack gap={16} key={mountKey}>
        {children}
      </VStack>
    </VStack>
  );
};

export { ReplayAnimationDecorator };
